<div id="particles-js">
	<canvas class="particles-js-canvas-el" style="width: 100%; height: 100%;"></canvas>
</div>
<div class="pill-button" *ngIf="selected">
	<div class="company-data">
		<span style="font-size: 0.8em; color: grey;">Continuar con la empresa</span>
		<br>
		<span><b>{{selected.companyName}}</b></span>
		<br>
		<span style="font-size: 0.7em;">{{selected.companyId}}</span>
	</div>
	<div class="continue-button">
		<button type="button" class="btn" (click)="sendCompany()">
			<i class="fa fa-angles-right"></i>
		</button>
	</div>
</div>
<div class="container-company">
	<div class="companies card">
		<div class="card-body">
			<h1>Empresas <i [appCheckPermission]="[5041]" [permissionType]="perms.CREATE" (click)="modalCompany = true;"
					[tooltip]="'Crear empresa'" class="fa fa-circle-plus text-info clickeable"></i>
			</h1>
			<span>Elige una empresa para continuar</span>
			<div class="form-group">
				<input type="text" name="filter" id="filter" placeholder="Filtra por nombre o código" (keyup)="filter()"
					class="form-control" [(ngModel)]="filterWord">
			</div>
			<div class="row row-cols-1 row-cols-md-3 g-4 companies-group" *ngIf="newPagination.total.length > 0">
				<div class="col" [ngClass]="i < 3 ?'margin-no-top':''"
					*ngFor="let showing of newPagination.filter; let i = index">
					<div class="card h-100 card-custom" [class.company-blocked]="!showing.activePartner" *ngIf="showing.companyNIT != 'ADMIN'"
						style="background-image: url('{{showing.companyLogo==templateSrc ? templateImg : showing.companyLogo}}')"
						[class.check-div]="selected?.companyId == showing.companyId" (click)="selectCompany(showing)">
						<div class="for-backdrop" [class.checkmark]="selected?.companyId == showing.companyId">
							<div class="card-img-div">
								<img src="{{showing.companyLogo==templateSrc ? templateImg : showing.companyLogo}}"
									class="card-img-top card-image-costum" alt="..."
									(error)="$event.target.src = '../../../../../assets/img/nophoto.svg'">
							</div>
							<div class="card-body">
								<h5 class="card-title" title="{{showing.companyName}}">
									<b>{{showing.companyName.substring(0, 30).replace(',,','
										')}}{{showing.companyName.length > 30 ? "..." : ""}}</b>
								</h5>
								<p class="card-text" style="margin: 0 !important;">Código:
									<b>{{showing.alphanumericId}}</b>
								</p>
								<p class="card-text" style="margin: 0 !important; padding: 0;">NIT:
									<b>{{showing.companyNIT}}</b>
								</p>
							</div>
							<div class="card-img-div custom-height" *ngIf="selected?.companyId == showing.companyId">
								<button type="button" (click)="sendCompany()" class="btn btn-primary">CONTINUAR <i
										class="fa fa-angles-right"></i></button>
							</div>
						</div>
						<div class="company-blocked-message" *ngIf="!showing.activePartner">
							<span class="h2">
								<i class="fa fa-ban text-danger"></i>
							</span>
							<span class="h2" style="font-weight: bolder;">Empresa bloqueada</span>
							<span class="text-muted">Contacte con el administrador</span>
						</div>
					</div>
					<div class="card h-100 card-custom" *ngIf="showing.companyNIT == 'ADMIN'">
						<div class="for-backdrop in-admin">
							<div class="card-img-div">
								<img src="assets/img/inSalesCC.png" style="background-color: #195d35; padding: 1em;"
									class="card-img-top card-image-costum" alt="...">
							</div>
							<div class="card-body">
								<h5 class="card-title">
									IN ADMIN
								</h5>
								<button class="btn btn-primary" (click)="goToInAdmin()">
									IR<i class="fa fa-angles-right"></i>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- <div *ngIf="selected" class="mb-3">
				<h1>Empresa seleccionada</h1>
				<div class="input-group input-group-sm">
					<label for="id" class="input-group-text">ID</label>
					<input type="text" name="id" id="id" value="{{selected.companyId}}" class="form-control" disabled>
					<label for="name" class="input-group-text">Nombre</label>
					<input type="text" name="name" id="name" value="{{selected.companyName}}" class="form-control" disabled>
					<button type="button" class="btn btn-primary" (click)="sendCompany()">Continuar</button>
				</div>
			</div> -->
			<app-pagination-custom
				(changed)="onPaginationChanged($event)"
				[elements]="newPagination">
			</app-pagination-custom>
			<!-- <nav aria-label="Page navigation example" *ngIf="newPagination.filter.length > 0">
				<ul class="pagination justify-content-center">
					<li class="page-item" [class.disabled]="start < 2">
						<a class="page-link" (click)="previous()" aria-label="Previous">
							<span aria-hidden="true">&laquo;</span>
						</a>
					</li>
					<li class="page-item" *ngFor="let i of [0,1,2,3,4]"
						[class.disabled]="pagination[i]*step >= companies.length+step">
						<a class="page-link" (click)="select(i)" [class.active]="pagination[i]==start">{{pagination[i]}}</a>
					</li>
					<li class="page-item" [class.disabled]="pagination[2]*step >= companies.length+step">
						<a class="page-link" (click)="next()" aria-label="Next">
							<span aria-hidden="true">&raquo;</span>
						</a>
					</li>
				</ul>
			</nav> -->
			<div *ngIf="newPagination.filter.length == 0" class="not-found-div">
				<span class="not-found">
					<i class="fa-solid fa-filter-circle-xmark"></i>
				</span>
				<h1 class="lead">No se encontraron resultados para: <b style="font-weight: 900;">{{filterWord}}</b></h1>
			</div>
		</div>
	</div>
</div>
<app-modal-company *ngIf="modalCompany" (close)="closeModalCompany($event)"></app-modal-company>

<button type="button" class="logout-floating-btn" (click)="logout()">
	<i class="fa fa-right-from-bracket" style="transform: rotate(180deg);"></i>
	<span>Salir</span>
</button>